// MEMO: import this for IE11.
// MEMO: Swiper 5.4.5 works on IE11.
import Swiper from "../../node_modules/swiper/js/swiper";

var swiper = new Swiper(".swiper-simple", {
  spaceBetween: 22,
  slidesPerView: "auto",
  centeredSlides: true,
  loop: true,

  // autoplay: {
  //   delay: 2000,
  // },

  navigation: {
    nextEl: ".swiper-button-next-simple",
    prevEl: ".swiper-button-prev-simple",
  },

  breakpoints: {
    992: {
      slidesPerView: 3,
      centeredSlides: false,
    },
  }
});


var swiperLogo1 = new Swiper(".swiper-logo-1", {
  slidesPerView: "auto",
  centeredSlides: true,
  spaceBetween: 30,
  initialSlide: 2,
  loop: true,
  speed: 6500,
  allowTouchMove: false,
  autoplay: {
    enabled: true,
    delay: 1,
  },

  // navigation: {
  //   nextEl: ".swiper-button-next-logo",
  //   prevEl: ".swiper-button-prev-logo",
  // },
});

var swiperLogo2 = new Swiper(".swiper-logo-2", {
  slidesPerView: "auto",
  centeredSlides: true,
  spaceBetween: 30,
  initialSlide: 2,
  loop: true,
  speed: 6500,
  allowTouchMove: false,
  autoplay: {
    enabled: true,
    delay: 1,
  },

  // navigation: {
  //   nextEl: ".swiper-button-next-logo",
  //   prevEl: ".swiper-button-prev-logo",
  // },
});
